import React, { useState, useEffect } from 'react';
import { usePWAInstall } from '../../context/PWAInstallContext';
import { LOGOS } from '../../constants/imageConstants';
import { Button } from '../buttons/button';

const PWA_INSTALL_DISMISSED_KEY = 'pwaInstallDismissed';

export const InstallPWADrawer = () => {
  const { canInstall, triggerInstall } = usePWAInstall();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const isDismissed = localStorage.getItem(PWA_INSTALL_DISMISSED_KEY);
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
    const isInWebAppiOS = window.navigator.standalone === true;
    const isInstalled = isStandalone || isInWebAppiOS;

    if (canInstall && !isInstalled) {
      if (!isDismissed) {
        const timer = setTimeout(() => {
          setIsVisible(true);
        }, 3000); 
        return () => clearTimeout(timer);
      } else {
        const dismissedTime = parseInt(isDismissed);
        const now = Date.now();
        const twentyFourHours = 24 * 60 * 60 * 1000;
        
        if (now - dismissedTime > twentyFourHours) {
          localStorage.removeItem(PWA_INSTALL_DISMISSED_KEY);
          const timer = setTimeout(() => {
            setIsVisible(true);
          }, 5000); 
          return () => clearTimeout(timer);
        }
      }
    }
  }, [canInstall]);

  const handleInstall = () => {
    triggerInstall();
    setIsVisible(false);
  };

  const handleDismiss = () => {
    localStorage.setItem(PWA_INSTALL_DISMISSED_KEY, Date.now().toString());
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="lg:hidden">
      <div
        className="fixed inset-0 bg-black/30 backdrop-blur-sm z-40 transition-opacity duration-300 animate-fade-in"
        onClick={handleDismiss}
      />
      <div
        className="fixed bottom-0 left-0 right-0 z-50 bg-white p-4 pb-5 rounded-t-2xl shadow-[0_-10px_30px_-15px_rgba(0,0,0,0.1)] transform transition-transform duration-300"
        style={{ transform: 'translateY(0)' }}
      >
        <div className="max-w-md mx-auto">
          <button
            onClick={handleDismiss}
            className="absolute top-2 right-2 p-2 rounded-full hover:bg-gray-100"
            aria-label="Dismiss"
          >
            <svg
              className="w-4 h-4 text-gray-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
          <div className="flex items-center gap-4 mb-4">
            <img
              src={LOGOS.NGO_BLUE}
              alt="App Logo"
              className="w-14 h-14 rounded-xl object-contain"
            />
            <div>
              <h3 className="font-bold text-gray-800 text-lg">Install The App</h3>
              <p className="text-sm text-gray-500">
                Add to Home Screen for a better experience.
              </p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <Button
              onClick={handleInstall}
              variant="primary"
              className="flex-1 h-11"
            >
              Install
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};